import React, { useCallback, useEffect, useRef, useState } from 'react';
import { themeButtons } from "../../css/themeButtons";
import { Field, Form, Formik, useFormikContext } from "formik";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Collapse from "@material-ui/core/Collapse";
import Preloader from "../common/Preloader/Preloader";
import DatePickerComponent from "../common/DatePickerComponent/DatePickerComponent";
import * as Yup from "yup";
import { NavLink } from "react-router-dom";
import { Link, useMediaQuery } from "@material-ui/core";
import { usePrevious } from "../common/CustomHook/usePrevious";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextFieldCustom } from "../ObjectAddNew/styles";
import { createFilterOptions } from "@material-ui/lab";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import { useRandomQueryUID } from "../common/CustomHook/randomQueryUID";
import { GreenRadio } from "../ObjectContacts/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import debounce from "lodash.debounce";


const contractTypeSwitcher = {
  "subscriber": "Абонентская оплата",
  "percent": "Комиссионная оплата"
}

const filterOptions = createFilterOptions({
  matchFrom: 'start',

});


const RenderInnField = ({ item, getEntityInfoByInn, validateINN, preset }) => {
  const [loadingCompany, setLoadingCompany] = useState(false)
  const { errors, values } = useFormikContext();


  const findCompanyByINN = async () => {
    setLoadingCompany((prev) => true)
    await getEntityInfoByInn({ inn: values.INN })
    setLoadingCompany((prev) => false)

  }

  const debouncedSubmit = useCallback(debounce(findCompanyByINN, 250),
    [findCompanyByINN]);

  const prevInn = usePrevious(values?.INN)
  useEffect(() => {
    if (values?.INN && values.INN.length === item.validate.length && !preset && values?.INN !== prevInn) {
      debouncedSubmit()
    }
  }, [values?.INN, errors?.INN])


  return (
    <>
      <Box className="d-flex">
        <Field name={item.code}
               validate={(value) => validateINN(value, item.validate)}>
          {({ field }) => (
            <TextField
              {...field}
              value={field.value}
              label={item.name}
              fullWidth
              size="small"
              variant="outlined"
              error={Boolean(errors.INN)}
              helperText={errors.INN}

            />
          )}
        </Field>
        {loadingCompany && <CircularProgress className="p-1"/>}
      </Box>
    </>
  )
};


const RenderContactEnabled = (props) => {
  const {
    object,
    entityType,
    getContractFieldsItem,
    fieldsCollections,
    presetsCollectios,
    presetSelect,
    setNextStage,
    getEntityInfoByInn,
    companyFindByINN
  } = props


  const [forceKey, setForceKey] = useState(Math.floor((Math.random() * 100) + 1))
  const [forceKeyInn, setForceKeyInn] = useState(Math.floor((Math.random() * 100) + 1))
  const formRef = useRef()


  useEffect(() => {
    getContractFieldsItem({
      object: object.id,
      country: object.country,
      stage: object.contract.stage
    })
  }, [])

  useEffect(() => {
    if (companyFindByINN) {
      formRef?.current.setValues({ ...formRef.current.values, ...companyFindByINN })
      setForceKey(Math.floor((Math.random() * 100) + 1))
    }

  }, [companyFindByINN])


  const onSubmit = (values) => {

    let fields = {}
    Object.keys(values).map(item => {
      if (!["entityType", "paymentType"].includes(item)) {
        fields = { ...fields, [item]: values[item] }
      }
    })

    setNextStage({
      object: object.id,
      entityType: values.entityType,
      country: object.country,
      stage: object.contract.stage,
      paymentType: values.paymentType,
      fields: JSON.stringify(fields),
      owner: values.owner,
      rentTo: values.rentTo,
    })

    return true
  }

  const changeEntityType = (entityTypeValue, values, form) => {


    form.setValues({
      entityType: entityTypeValue ? entityTypeValue : "",
      paymentType: values?.paymentType ? values.paymentType : "",
      owner: values?.owner ? values.owner : "",
      rentTo: values?.rentTo ? values.rentTo : "",
      requisite: values?.requisite ? values.requisite : "",
    })
    setForceKey(Math.floor((Math.random() * 100) + 1))

  }

  const changePresetSelect = (form, formValue, presetValue, presetItem) => {

    if (presetValue === "new") {

      form.setValues({
        paymentType: formValue.paymentType,
        entityType: formValue.entityType,
        requisite: presetValue
      })
      setForceKey(Math.floor((Math.random() * 100) + 1))
      setForceKeyInn(Math.floor((Math.random() * 100) + 1))
      return
    }


    form.setValues({
      ...formValue, ...presetsCollectios[presetItem][presetValue],
      requisite: presetValue
    })
    setForceKey(Math.floor((Math.random() * 100) + 1))
    setForceKeyInn(Math.floor((Math.random() * 100) + 1))
  }


  const validateINN = (value, itemValidate) => {
    let error;
    if (itemValidate.required && !value) {
      error = 'Обязательно к заполнению';
    }
    if (value && itemValidate.length && value.length !== itemValidate.length) {
      error = `Должен содержать ${itemValidate.length} символов`
    }
    return error;
  }


  const contractValidate = Yup.object().shape({
    owner: Yup.string()
      .required('Обязательно к заполнению'),
    rentTo: Yup.string()
      .when('owner', {
        is: (owner) => owner === "N",
        then: Yup.string()
          .required('Обязательно к заполнению')
          .nullable(),
        otherwise: Yup.string().nullable(),
      }),
  });


  const buttons = themeButtons()

  if (!fieldsCollections) {
    return <Preloader loading={true}/>
  }
  return (
    <div className="main">
      <div className="container-fluid">


        <Formik initialValues={{ requisite: "new", rentTo: null, entityType: "" }}
                enableReinitialize={true}
                innerRef={formRef}
                validationSchema={contractValidate}
                onSubmit={onSubmit}>
          {({ values, errors, isSubmitting, ...form }) => (
            <Form>

              <h4 className="mb-3">Договор {object.name}</h4>
              <Box className="alert alert-warning mb-3">
                <Typography variant={"h6"}><FontAwesomeIcon
                  icon="exclamation-triangle"/> Внимание!</Typography>
                <Typography>Модерация объектов сейчас проходит дольше,
                  чем обычно, в связи с большим количеством регистраций.</Typography>
                <Typography> Надеемся на Ваше понимание.</Typography>
              </Box>
              <div className="row mb-3 gy-3">
                <div className="col-lg-4">
                  <Field name="entityType">
                    {({ field, form }) => (
                      <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel>Договор на</InputLabel>
                        <Select
                          {...field}
                          label="Договор на"
                          onChange={(e) => {
                            field.onChange(e)
                            changeEntityType(e.target.value, values, form)
                          }}>

                          {entityType && entityType?.map(item => {
                            return <MenuItem key={item.id}
                                             className="justify-content-center"
                                             value={item.code}>
                              {item.name}
                            </MenuItem>
                          })}

                        </Select>
                      </FormControl>
                    )}
                  </Field>
                </div>
                <Collapse className="col-lg-4"
                          in={Boolean(values?.entityType && presetSelect[values?.entityType])}
                          timeout="auto" unmountOnExit>

                  {presetSelect[values.entityType] && <Field name="requisite">
                    {({ field, form }) => (
                      <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel>Тип договора</InputLabel>
                        <Select
                          {...field}
                          onChange={(e) => {
                            field.onChange(e)
                            changePresetSelect(form, values, e.target.value, values.entityType)
                          }}
                          label="Тип договора"
                        >
                          <MenuItem key={"new"} className="justify-content-center"
                                    value={"new"}>
                            Новый
                          </MenuItem>
                          {presetSelect && Object.keys(presetSelect[values?.entityType]).map(item =>
                            <MenuItem key={item} value={item}
                                      className="justify-content-center">
                              {presetSelect[values?.entityType][item]}
                            </MenuItem>
                          )}


                        </Select>
                      </FormControl>
                    )}
                  </Field>}

                </Collapse>
              </div>

              <Collapse in={Boolean(values.entityType !== "individual")}
                        timeout="auto"
                        unmountOnExit>
                <div className="row mb-3 gy-3">
                  <div className="col-lg-6">
                    {fieldsCollections && values?.entityType && fieldsCollections[values?.entityType].filter(item => item.code === "INN").map(item =>
                      <RenderInnField key={forceKeyInn} item={item}
                                      preset={values.requisite !== "new"}
                                      getEntityInfoByInn={getEntityInfoByInn}
                                      validateINN={validateINN}/>)}
                  </div>
                </div>

              </Collapse>
              <Collapse
                in={Boolean(!errors.INN && values.INN || values?.entityType === "individual")}
                timeout="auto" unmountOnExit>
                <div className="row mb-3 gy-3">
                  {fieldsCollections && values?.entityType && fieldsCollections[values?.entityType].map(item => item.code !== "INN" &&
                    <div key={forceKey + item.code} className="col-lg-4">
                      <Field name={item.code}>
                        {({ field, form }) => (
                          <TextField
                            {...field}
                            label={item.name}
                            fullWidth
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Field>
                    </div>
                  )}

                </div>
              </Collapse>

              <Box className="mb-3">
                <div className="row gy-3">
                  <div className="col">
                    <Field type="radio" name={"owner"}>
                      {({ field }) => (
                        <>
                          <RadioGroup {...field}>
                            <div>
                              <FormControlLabel value={"Y"} className="me-5"
                                                control={<GreenRadio/>}
                                                label={"Объект в собственности"}/>
                              <FormControlLabel value={"N"} control={<GreenRadio/>}
                                                label={"Объект в управлении/аренде"}/>
                            </div>


                          </RadioGroup>
                          {Boolean(errors.owner)
                            ? <FormHelperText
                              style={{
                                color: "#f44336",
                              }}>{errors.owner}</FormHelperText>
                            : null}

                        </>
                      )}
                    </Field>
                  </div>
                  <div className="col">
                    <Collapse
                      unmountOnExit
                      in={values.owner === "N"}
                      timeout="auto">
                      <DatePickerComponent
                        name="rentTo"
                        label={"Аренда до"}
                        minDate={new Date()}
                        error={Boolean(errors.rentTo)}
                        helperText={errors.rentTo}/>

                    </Collapse>
                  </div>

                </div>
              </Box>


              <Collapse
                in={Boolean(!errors.INN && values.INN) || values.entityType === "individual"}
                timeout="auto" unmountOnExit mountOnEnter>

                <Button type="submit"
                        disabled={isSubmitting}
                        className={`btn ${buttons.btnGreen}`}>
                  Отправить
                </Button>

              </Collapse>
            </Form>
          )}

        </Formik>
      </div>
    </div>

  )
}


const RenderContractPreparation = (props) => {
  const {
    object, requisiteId, fields,
    fieldsCollections, entityType,
    getContractFieldsItem, setNextStage, getCities,
    citiesList, citiesListReversed, getCatalogList,
    catalogList, catalog, city
  } = props


  const [initValue, setInitValue] = useState({
    requisite: '',
    city: '',
    catalog: '',
    entityType: ''
  })


  useEffect(() => {
    getCities({ country: object.country })
  }, [])


  const prevEntityType = usePrevious(entityType?.code)

  useEffect(() => {
    if (entityType && entityType.code && entityType.code !== prevEntityType) {
      getContractFieldsItem({
        object: object.id,
        entityType: entityType?.code,
        country: object.country,
        stage: object.contract.stage,
      })
    }
  }, [entityType])


  useEffect(() => {
    if (fieldsCollections && fields && entityType && entityType.code) {

      let newInitValue = {}

      fieldsCollections[entityType.code].map(item => {
        newInitValue = { ...newInitValue, [item.code]: fields[item.code] }
      })

      newInitValue = {
        ...newInitValue,
        entityType: entityType.code,
        catalog: catalog && city && citiesList[city] ? catalog : null,
        city: city && citiesList[city] ? citiesList[city] : '',
        dateRenewal: new Date().setFullYear(new Date().getFullYear() + 1)
      }


      setInitValue(newInitValue)
    }
  }, [fieldsCollections, fields, catalog, city])


  const onSubmit = async (values) => {

    let fields = {}
    Object.keys(values).map(item => {
      if (!["entityType", "paymentType"].includes(item)) {
        fields = { ...fields, [item]: values[item] }
      }
    })

    await setNextStage({
      object: object.id,
      entityType: values.entityType,
      country: object.country,
      stage: object.contract.stage,
      fields: JSON.stringify(fields),
      requisite: requisiteId,
      catalog: values.catalog,
      city: citiesListReversed[values.city]
    })

    return true
  }


  const contractSchema = Yup.object().shape({
    catalog: Yup.string().required('Поле не заполнено'),
    city: Yup.string().required('Поле не заполнено'),
  });


  const formRef = useRef();


  const changeCityHandler = (value) => {
    if (formRef.current) {
      getCatalogList({ country: object.country, city: citiesListReversed[value] })
      formRef.current.setFieldValue("city", value || "")
    }
  }

  useEffect(() => {
    if (city && !catalogList) {
      getCatalogList({ country: object.country, city: city })
    }
  }, [city])


  const buttons = themeButtons()
  if (!entityType && !fieldsCollections) {
    return <Preloader loading={true}/>
  }
  return (
    <div className="main">
      <div className="container-fluid">
        <Formik innerRef={formRef}
                initialValues={{ ...initValue }}
                enableReinitialize
                validationSchema={contractSchema}
                onSubmit={onSubmit}>
          {({ values, errors, isSubmitting, setFieldValue, touched }) => (
            <Form>
              <h4 className="mb-3">Договор {object.name}</h4>
              <div id="contract-type">
                <div className="alert alert-warning">
                  Проверьте заполнения договора от отельера, укажите стоимость размещения и дату
                  окончания договора
                </div>
                <div className="row mb-3 g-3">
                  <div className="col-lg-4">
                    <Field name="entityType" key={Math.random()}>
                      {({ field, form }) => (
                        <FormControl variant="outlined" size="small" fullWidth disabled>
                          <InputLabel>Договор на</InputLabel>
                          <Select
                            {...field}
                            label="Договор на">

                            <MenuItem
                              className="justify-content-center"
                              value={entityType && entityType?.code}>
                              {entityType && entityType?.value}
                            </MenuItem>


                          </Select>
                        </FormControl>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="row mb-3 g-3">
                  {fieldsCollections && entityType && entityType.code && fieldsCollections[entityType.code].map(item =>
                    <div key={item.code} className="col-lg-4">
                      <Field name={item.code}>
                        {({ field, form }) => (
                          <TextField
                            {...field}
                            label={item.name}
                            fullWidth
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Field>
                    </div>
                  )}
                </div>
                <div className="row mb-3 g-3">
                  <div className="col-lg-4">
                    <Field name="city">
                      {({ field, form }) => (

                        <Autocomplete
                          freeSolo
                          inputValue={field.value}
                          filterOptions={filterOptions}
                          options={citiesList && Object.keys(citiesList).map((option) => citiesList[option])}
                          onChange={(e, value) => changeCityHandler(value)}
                          // onInputChange={(e, value) => changeCityHandler(value)}
                          renderInput={(params) => <TextFieldCustom {...params}
                                                                    label="Город"
                                                                    fullWidth size="small"
                                                                    variant="outlined"

                                                                    {...field}
                                                                    inputProps={{
                                                                      ...params.inputProps,
                                                                      autoComplete: "new-password"
                                                                    }}
                                                                    error={Boolean(errors.city && touched.city)}
                                                                    helperText={
                                                                      errors.city &&
                                                                      touched.city &&
                                                                      String(errors.city)
                                                                    }
                          />}
                        />


                      )}
                    </Field>

                  </div>
                  <div className="col-lg-4">
                    <Field name="catalog">
                      {({ field, form }) => (
                        <FormControl variant="outlined" size="small" fullWidth>
                          <InputLabel>Каталог</InputLabel>
                          <Select
                            {...field}
                            label="Каталог">


                            {catalogList && Object.keys(catalogList).map(id => <MenuItem
                              className="justify-content-center"
                              value={`${id}`} key={id}>
                              {catalogList[id]}
                            </MenuItem>)}


                          </Select>
                        </FormControl>
                      )}
                    </Field>

                  </div>
                </div>
                <div className="row mb-3 g-3">
                  <div className="col-lg-4">
                    <DatePickerComponent
                      name="dateRenewal"
                      label={"Договор действует до"}
                      minDate={new Date()}
                      error={Boolean(errors.dateRenewal)}
                      helperText={errors.dateRenewal}/>

                  </div>
                </div>


                <div className="col-12">
                  <Button type="submit" disabled={isSubmitting}
                          className={`btn ${buttons.btnGreen} me-2`}>Отправить</Button>
                </div>
              </div>

            </Form>
          )}

        </Formik>
      </div>
    </div>
  )
}


const RenderContractVerification = (props) => {
  const { object, paymentType, contract, prices, baseUrl, setNextStage, channelManager } = props
  const mobileAgent = useMediaQuery('(max-width: 974px)');

  const randomQueryUID = useRandomQueryUID()

  const confirmContract = (values) => {
    setNextStage({
      object: object.id,
      country: object.country,
      stage: object.contract.stage,
      paymentType: values.paymentType
    })
  }

  const buttons = themeButtons()

  if (!paymentType) {
    return <Preloader loading={true}/>
  }
  return (
    <div className="main">
      <div className="container-fluid">
        <h4 className="mb-3">Договор {object.name}</h4>

        <Formik initialValues={{ paymentType: null }}
                enableReinitialize
                onSubmit={confirmContract}>
          {({ values, setFieldValue, isSubmitting, submitForm }) => (
            <Form>
              <div id="contract-type">
                <div className="alert alert-warning">
                  Выберите тип договора с нами
                </div>
                {values?.paymentType === "6562" && channelManager && (<div className="alert alert-warning">
                  <b>Менеджер каналов недоступен при абонентском размещении.</b>
                  <br/>
                  Если вы решили размещаться в абонентском
                  формате, менеджер каналов для объекта {object.name} будет отключен

                </div>)}
                <div className="row mb-4 gy-3">
                  {paymentType && paymentType.map(item => {
                    item.id = Number(item.id);
                    return <div key={item.id} className="col-md ">
                      <Card
                        onClick={() => setFieldValue("paymentType", item.id)}
                        className={`card contract-type__card h-100 ${values.paymentType === item.id && "active"}`}>
                        <CardContent className="h-100 d-flex flex-column">
                          <div className="card-header">
                            <h6 className="card-title">{contractTypeSwitcher[item.code]}</h6>

                            {values.paymentType === item.id
                              ? <><FontAwesomeIcon icon={["far", "check-circle"]}
                                                   className="ms-1 text-success me-auto"/>
                                <Button type="button"
                                        className={`btn ${buttons.btnLight}`}>Выбрано</Button></>
                              : <Button type="button"
                                        className={`btn ${buttons.btnGreen}`}>Выбрать</Button>
                            }

                          </div>
                          {item.code === "percent"
                            ? <div className="card-body">
                              <ul>
                                <li>Бесплатное размещение на сайте сразу</li>
                                <li>Оплата только за успешные бронирования</li>
                                <li><b>Доступно</b> подключение менеджера каналов</li>
                              </ul>

                              <div className="contract-type__price">
                                <p className="title">Комиссия за бронирования:</p>
                                <p className="sum">{prices.percent}</p>
                              </div>
                            </div>
                            : <div className="card-body">
                              <ul>
                                <li>На странице объекта указываются ваши прямые
                                  контакты: телефон, e-mail и мессенджеры
                                </li>
                                <li>Получайте все брони напрямую - и не платите
                                  комиссии
                                </li>
                                <li>Единоразовая абонентская оплата за год</li>
                                <li><b>Недоступно</b> подключение менеджера каналов</li>
                              </ul>

                              <div className="contract-type__price">
                                <p className="title">Стоимость размещения:</p>
                                <p className="sum">{prices.subscriber}</p>
                              </div>
                            </div>
                          }

                        </CardContent>
                      </Card>
                    </div>
                  })}
                </div>
              </div>

              <Collapse
                in={paymentType.find(type => type.id === values?.paymentType)?.code === "percent"}
                timeout="auto">
                <iframe src={`${baseUrl}/lk${contract.percent}?a=${randomQueryUID}`}
                        style={{ height: mobileAgent ? "50vh" : "75vh", width: "1px", minWidth: "100%" }}
                        frameBorder="0"
                        type="application/pdf"/>
              </Collapse>
              <Collapse
                in={paymentType.find(type => type.id === values?.paymentType)?.code === "subscriber"}
                timeout="auto">
                <iframe src={`${baseUrl}/lk${contract.subscriber}?a=${randomQueryUID}`}
                        style={{ height: mobileAgent ? "50vh" : "75vh", width: "1px", minWidth: "100%" }}
                        frameBorder="0"
                        type="application/pdf"/>
              </Collapse>

              {values.paymentType &&
                <StickyBottomButton action={submitForm} disbaledBtn={isSubmitting || !values.paymentType}
                                    btnText={"Согласен(-нa) с условиями договора"}/>}

            </Form>
          )}
        </Formik>


      </div>
    </div>
  )
}


const RenderContractConcluded = (props) => {
  const { object, paymentType, entityType, contract, baseUrl, downloadContract, blobLink } = props
  const mobileAgent = useMediaQuery('(max-width: 974px)');


  const randomQueryUID = useRandomQueryUID()

  useEffect(() => {

    if (object && !entityType) {
      downloadContract({ object: object.id, country: object.country })
    }
  }, [object])


  const buttons = themeButtons()
  if (!contract) {
    return <Preloader loading={true}/>
  }
  return (
    <div className="main">
      <div className="container-fluid">
        <h4 className="mb-3">Договор {object.name}</h4>

        <iframe src={`${baseUrl}/lk${contract}?a=${randomQueryUID}`}
                style={{ height: mobileAgent ? "50vh" : "75vh", width: "1px", minWidth: "100%" }} frameBorder="0"
                type="application/pdf"/>


        <Button component={Link} disabled={!blobLink} className={`btn ${buttons.btnWarn} mt-2`}
                href={blobLink} download="contract.pdf">Скачать договор</Button>
      </div>
    </div>
  )
}


const RedirectWithSuccessMessage = () => {


  const buttons = themeButtons();
  return (
    <div className="main">
      <div className="container-fluid">
        <div className="w-100 mt-5 text-center">
          <h5 className="mb-3">Поздравляем!</h5>

          <Typography className="mb-3" variant="body1" display="block">
            Вы успешно заполнили данные для договора. Ожидайте проверки данных модератором
          </Typography>

          <Box className="alert alert-warning mb-3">
            <Typography variant={"h6"}><FontAwesomeIcon icon="exclamation-triangle"/> Внимание!</Typography>
            <Typography>Модерация объектов сейчас проходит дольше,
              чем обычно, в связи с большим количеством регистраций.</Typography>
            <Typography> Надеемся на Ваше понимание.</Typography>
          </Box>

          <Button className={`btn ${buttons.btnGreen}`} component={NavLink} to={`/lk/contracts`}
                  variant="contained">Вернуться к списку договоров</Button>

        </div>

      </div>
    </div>
  )
}

const ContractDetail = (props) => {
  const { object, searchObjects, getContractInfo, userRole } = props


  useEffect(() => {
    if (!object) {
      searchObjects(props.match.params.contractId)
    }
  }, [])


  const prevStage = usePrevious(object?.contract?.stage)
  useEffect(() => {
    if (object && prevStage !== object.contract.stage) {
      getContractInfo({ object: object.id, country: object.country, stage: object.contract.stage })
    }
  }, [object])


  /*
  TODO error contract not found
  if(!object && objectsList && objectsList.length === 0) {
      return "asdasd"
  }*/
  if (!object) {
    return <Preloader loading={true} text={"Загружаем договор"}/>
  }

  if (object.contract.stage === "disabled") {
    return (
      <div className="main">
        <div className="container-fluid">
          {object.contract.condition.length !== 0 &&
            <div className="contract__addition alert alert-danger">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2"/>
              Для заключения договора необходимо заполнить обязательные пункты:
              <ol className="m-0 ms-3">
                {Object.keys(object.contract.condition).map((item) => {
                    return <li key={item}><Link component={NavLink}
                                                to={object.contract.condition[item].link}>{object.contract.condition[item].text}</Link>
                    </li>
                  }
                )}

              </ol>
            </div>}
        </div>
      </div>
    )
  }
  if (userRole !== "MODERATOR" && object.contract.stage === "preparation") {
    return <RedirectWithSuccessMessage/>
  }

  if (object.contract.stage === "enabled") {
    return <RenderContactEnabled {...props}/>
  }

  if (object.contract.stage === "preparation") {
    return <RenderContractPreparation {...props}/>
  }

  if (object.contract.stage === "verification") {
    return <RenderContractVerification {...props}/>
  }

  if (object.contract.stage === "concluded") {
    return <RenderContractConcluded  {...props}/>
  }
}


export default ContractDetail;
